export const TITULO_PAGINA = 'Retirar Processo do Controle de Expiração';
export const SUBTITULO_PAGINA = 'Informe o Processo que deseja retirar do Controle de Expiração.';

export const MAX_LENGTH_NUM_PROCESSO = 11;

export const MINIMO_PALAVRAS_JUSTIFICATIVA = 3;
export const MAX_COUNTER_JUSTIFICATIVA = 500;

export const LABEL_NUMERO_PROCESSO = 'Número do Processo:';
export const LABEL_NOME_CLIENTE = 'Nome do Cliente';
export const LABEL_JUSTIFICATIVA = 'Justificativa*';
export const LABEL_RETIRAR_CONTROLE = 'Retirar do Controle de Expiração';

export const MENSAGEM_ERRO_BUSCA_PROCESSO = 'Nenhum resultado foi encontrado relacionado à sua pesquisa';

// Textos idênticos aos literais usados pelo backend (abe-web-core-spring,
// AW2-1290-retirar-controle-expiracao-processo.md, Etapa 5) — mesma ordem de validação do
// servidor (baixado -> já retirado -> cliente sem controle), para que o bloqueio exibido aqui
// nunca divirja do erro que o próprio PUT retornaria para o mesmo processo.
export const MENSAGEM_BLOQUEIO_PROCESSO_BAIXADO = 'Este processo já está baixado e não pode ser retirado do controle de expiração.';
export const MENSAGEM_BLOQUEIO_JA_FORA_DO_CONTROLE = 'Este processo já está fora do controle de expiração.';
export const MENSAGEM_BLOQUEIO_CLIENTE_SEM_CONTROLE = 'O cliente deste processo não possui controle de expiração.';

export const MENSAGEM_CONFIRMACAO_ALTERACAO = 'Este processo será retirado do controle de expiração. Esta operação não poderá ser desfeita. Deseja continuar?';
export const MENSAGEM_SUCESSO_ALTERACAO = 'Processo retirado do controle de expiração com sucesso.';
export const MENSAGEM_ERRO_ALTERACAO = 'Não foi possível retirar este processo do controle de expiração.';
export const MENSAGEM_ERRO_HISTORICO_AUTOMATICO = 'Processo retirado do controle de expiração, mas não foi possível registrar o histórico automático desta alteração.';
